<template>
	<div class="c-empty">
		<SvgIcons v-if="isSlideTmpl" name="icon_empty_slide" class="c-empty-svg" />
		<SvgIcons v-else name="icon_empty" class="c-empty-svg" />
		<span class="c-empty-span">{{ defineText }}</span>
	</div>
</template>
<script setup>
import { computed, getCurrentInstance } from 'vue';
import SvgIcons from '@/components/SvgIcons.vue';
import { useCommonData } from '@/hooks';

const { proxy } = getCurrentInstance();

const props = defineProps({
	text: {
		type: String,
		default: ''
	}
});

const defineText = computed(() => {
	return props.text || proxy.$t('enterprise.no-data');
});

const { isSlideTmpl } = useCommonData();
</script>
<style lang="less" scoped>
.c-empty {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 200px;

	.c-empty-svg {
		width: 280px;
		height: 120px;
	}
	.c-empty-span {
		font-size: 12px;
		font-weight: 400;
		line-height: 16px;
		color: #4e5969;
	}
}
</style>
